export const ACHIEVEMENT = {
    STATUS: {
        ACCEPTANCE_OR_DENIAL: 'ACCEPTANCE_OR_DENIAL',
        REJECTION: 'REJECTION',
        BLANK: 'BLANK',
        REQUEST_DELETE: 'REQUEST_DELETE'
    },
    JWNET: {
        START_TIME: '07:00:00',
        END_TIME: '19:00:00'
    }
}